<script setup lang="ts">
import { ref } from 'vue';
import { locale } from '../../locale';
import ToolTip from '../ToolTip.vue';
import DeviceAllert from '../icons/DeviceAllert.vue';
import { desiredMediaState, microDeviceError } from '../../states/media/state';
import { mediaActions } from '../../states/media/actions';

const btn = ref<HTMLElement | null>(null)
const emit = defineEmits(['click'])
const toggle = () => {
  if(microDeviceError.value) return
  if(desiredMediaState.microEnabled) {
    mediaActions.microOff()
  } else {
    mediaActions.microOn()
  }
}
</script>
<template>
  <button ref="btn" class="micro-button" :class="{
    error: !!microDeviceError
  }" @click="toggle">
    <svg v-if="desiredMediaState.microEnabled" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 10.08V11.04C6 12.8223 6.63214 14.5315 7.75736 15.7918C8.88258 17.052 10.4087 17.76 12 17.76M12 17.76C13.5913 17.76 15.1174 17.052 16.2426 15.7918C17.3679 14.5315 18 12.8223 18 11.04V10.08M12 17.76V21.6M12 21.6H10.5M12 21.6H13.5M12 2.4C13.4202 2.4 14.5714 3.68942 14.5714 5.28V11.04C14.5714 12.6306 13.4202 13.92 12 13.92C10.5798 13.92 9.42857 12.6306 9.42857 11.04V5.28C9.42857 3.68942 10.5798 2.4 12 2.4Z"
        stroke="#292929" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.99961 10.08V11.04C5.99961 12.8223 6.47938 14.4598 7.67961 15.72C8.87984 16.9802 10.3022 17.76 11.9996 17.76M11.9996 17.76C13.697 17.76 15.2994 16.8602 16.4996 15.6C16.5444 15.553 16.7472 15.6972 16.7905 15.649M11.9996 17.76V21.6M17.9996 10.08V11.04C17.9996 11.6684 17.9807 12.0063 17.8196 12.6M11.9996 21.6H10.4996M11.9996 21.6H13.7329M3.59961 2.4L14.149 12.9928M20.3996 19.2L16.7905 15.649M9.39009 8.21429V11.04C9.39009 12.6306 10.4848 13.92 11.9996 13.92C12.7968 13.92 13.6479 13.5629 14.149 12.9928M14.149 12.9928L16.328 15.1807L16.7905 15.649M14.5796 9.33334V5.28C14.5796 3.66 13.3663 2.4 11.9996 2.4C10.4996 2.4 9.83961 3.6 9.64835 4.05836"
        stroke="#292929" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <ToolTip :placement="'top'" :reference="btn">{{ microDeviceError ? locale.deviceErrors.common : desiredMediaState.microEnabled ? locale.voiceoff : locale.voiceon }}</ToolTip>
    <div v-if="microDeviceError" class="error-allert">
      <DeviceAllert />
    </div>
  </button>
</template>
<style scoped>
.micro-button {
  width: 36px;
  height: 36px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: rgba(236, 236, 236, 0.85);
  border-radius: 50px;
  border: none;
  cursor: pointer;
  position: relative;
}

.error-allert {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 16px;
  height: 16px;
}

.micro-button.error {
  cursor: default;
}

.micro-button:hover:not(.error) {
  background-color: #F6F6F6;
}

.micro-button:active:not(.error) {
  background-color: #DBDBDB;
}

.micro-button:focus:not(.error) {
  outline: none;
}

.micro-button:disabled {
  pointer-events: none;
}
</style>
